import { render, staticRenderFns } from "./Unavailable.vue?vue&type=template&id=0aff428a&scoped=true"
import script from "./Unavailable.vue?vue&type=script&lang=js"
export * from "./Unavailable.vue?vue&type=script&lang=js"
import style0 from "./Unavailable.vue?vue&type=style&index=0&id=0aff428a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff428a",
  null
  
)

export default component.exports